<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="$store.state.stringsStore.strings.module.users.list.filter.label"
            />
          </div>
        </div>
      </div>
      <!-- Invite button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-permission="'users.add'"
          class="capitalize ctrl-button right"
          color="ctrl-turquoise"
          :label="`${$store.state.stringsStore.strings.action.invite}`"
          @click="$router.push('/users/invite')"
          icon-right="add"
        />
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
    <div v-if="!hideFilters" class="table-block q-mb-md">
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
            v-model="filters.name"
            @input="applyFilters"
            float-label="User"/>
        </div>
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
          v-model="filters.email"
          @input="applyFilters"
          float-label="Email"/>
        </div>
      </div>
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Checkbox active -->
        <q-checkbox
          class="select-text q-pa-md"
          :color="checkboxActive"
          toggle-indeterminate
          v-model="filters.active"
          @input="applyFilters"
          label="Active"
        />
        <div class="q-pa-md" style="vertical-align: middle;">
          <q-btn
            :disable="!activeFilters"
            @click="resetFilters()"
            class="capitalize ctrl-button"
            :color="activeFilters ? 'primary' : 'grey-4'"
            label="Reset"
          />
        </div>
      </div>
    </div>
    </transition>
    <table-overview
      :endpoint="endpoint"
      :responseFormat="'users'"
      :columns="columns"
      :permission="permission"
      :module="module"
      :selectable="false">
    </table-overview>
  </div>
</template>

<script>
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';
import common from '../common';

export default {
  mixins: [
    common,
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      isLoading: false,
      columns: [
        {
          name: '__slot:users-name',
          title: getString('user'),
          sortField: 'name',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
        {
          name: '__slot:users-email',
          title: getString('email'),
          sortField: 'email',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l email text-ellipsis',
        },
        {
          name: 'lastLogin',
          title: getString('module.users.list.table.column.lastLogin'),
          sortField: 'lastLogin',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m text-ellipsis',
          callback: 'tableFormatTime',
        },
        {
          name: '__slot:users-active',
          title: getString('active'),
          sortField: 'active',
          titleClass: 'text-left sortable vcol-xs',
          dataClass: 'text-left vcol-xs',
        },
      ],
      filters: {
        name: '',
        email: '',
        active: null,
      },
      searchTerm: '',
      hideFilters: true,
    };
  },
  computed: {
    checkboxActive() {
      return this.filters.active ? 'primary' : 'grey-4';
    },
  },
};
</script>
